import React, { useState } from 'react';
import classes from './Calculator.module.scss';
import i18n from '../../../../../../utils/i18n';
import IconVisible from '../../../../../../images/icon-visible.svg';
import IconEdit from '../../../../../../images/icon-edit.svg';
import IconTrashGrey from '../../../../../../images/icon-trash-grey.svg';
import CustomButton from '../../../../../components/CustomButton';
import IconOffice from '../../../../../../images/icon-office-blue.svg';
import IconPlusBlue from '../../../../../../images/icon-plus-blue.svg';
import DialogEditCompany from './DialogEditCompany';

import { useDispatch, useSelector } from 'react-redux';
import ACTIONS from '../../../../../../redux/action';

const Calculator = ({ providerData }) => {
	const store = useSelector((state) => state);
	const companyData = useSelector((state) => state.provider_example_companies);
	const [openDialogEditCompany, setOpenDialogEditCompany] = useState(false);
	const [selectedCompany, setSelectedCompany] = useState({});
	const [selectedId, setSelectedId] = useState('');

	const dispatch = useDispatch();
	const handleAddCompany = (event) => {
		if (companyData.length < 4) {
			const newId = Date.now();
			const newCompany = {
				potential_providers: [],
				accountingprice: '',
				id: newId,
				name: 'întreprindere',
				icon: IconOffice,
				type: 'custom',
				isEditing: '',
				accounting: true,
				payroll: false,
				noofemployees: '0',
				yearlyrevenue: 0,
				incominginvoices: '0',
				outgoinginvoices: '0',
				industry: '',
				// industryspecifics: {
				// 	general: {
				// 		registersimplifiedpayroll: {
				// 			status: '',
				// 		},
				// 		severallocations: {
				// 			status: '',
				// 			locationcount: null,
				// 		},
				// 		companycar: {
				// 			status: '',
				// 			carcount: null,
				// 		},
				// 		cashregister: {
				// 			status: '',
				// 			cashregistercount: null,
				// 		},
				// 		multipleaccounts: {
				// 			status: '',
				// 			accountcount: null,
				// 		},
				// 		customertype: {
				// 			selectedoption: '',
				// 		},
				// 		cashflowvat: {
				// 			status: '',
				// 		},
				// 		loanreview: {
				// 			status: '',
				// 			reviewcount: null,
				// 			reviewfrequency: '',
				// 		},
				// 		earlyclosure: {
				// 			status: '',
				// 			earlyclosurefrequency: '',
				// 		},
				// 		preparingstatements: {
				// 			status: '',
				// 		},
				// 		invoicing: {
				// 			status: '',
				// 		},
				// 		transfering: {
				// 			status: '',
				// 		},
				// 		auditcooperation: {
				// 			status: '',
				// 		},
				// 		vatadjusting: {
				// 			status: '',
				// 		},
				// 		projectsupport: {
				// 			status: '',
				// 		},
				// 		environmentalfees: {
				// 			status: '',
				// 			handlingenvfees: '',
				// 		},
				// 	},
				// 	etrade: {
				// 		etradesells: {
				// 			physicalproducts: false,
				// 			services: false,
				// 			intellectualproperty: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 		etrademultiplecourier: {
				// 			mpl: false,
				// 			gls: false,
				// 			dpd: false,
				// 			sprinter: false,
				// 			expressone: false,
				// 			tntexpress: false,
				// 			fedex: false,
				// 			ups: false,
				// 			dhlexpress: false,
				// 			other: false,
				// 		},
				// 		etrademultipledropoff: {
				// 			foxpost: false,
				// 			alzabox: false,
				// 			packeta: false,
				// 			glscsomagpont: false,
				// 			dpdpickupcsomagpont: false,
				// 			mplpostapont: false,
				// 			other: false,
				// 		},
				// 		etradepayment: {
				// 			transfer: false,
				// 			card: false,
				// 			benefit: false,
				// 		},
				// 		matchinginvoices: {
				// 			status: '',
				// 			matchingmethod: '',
				// 		},
				// 		deadlinecompliance: {
				// 			status: '',
				// 		},
				// 		actualstore: {
				// 			status: '',
				// 			actualstorecount: null,
				// 		},
				// 		stockhandling: {
				// 			status: '',
				// 		},
				// 	},
				// 	vehicle: {
				// 		differentialvat: {
				// 			status: '',
				// 			automotivepartstrading: false,
				// 			trading: false,
				// 			service: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 	},
				// 	construction: {
				// 		constructiontype: {
				// 			specializedworks: false,
				// 			generalcontracting: false,
				// 			constructionprojects: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 	},
				// 	IT: {
				// 		ittype: {
				// 			wagereview: false,
				// 			projectwork: false,
				// 			ownprodsoftdev: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 	},
				// 	agriculture: {
				// 		agriculturetype: {
				// 			livestockfarming: false,
				// 			cropproduction: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 	},
				// 	art: {
				// 		arttype: {
				// 			createartworks: false,
				// 			performingartist: false,
				// 			tradeartworks: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 	},
				// 	beauty: {
				// 		beautyproductsales: {
				// 			status: '',
				// 		},
				// 	},
				// 	travel: {
				// 		travelpayment: {
				// 			transfer: false,
				// 			card: false,
				// 			benefit: false,
				// 		},
				// 		seasonalunits: {
				// 			status: '',
				// 		},
				// 		matchinginvoicestravel: {
				// 			status: '',
				// 			matchingmethod: '',
				// 		},
				// 		deadlinecompliancetravel: {
				// 			status: '',
				// 		},
				// 	},
				// 	// trade: {
				// 	// 	tradepayment: {
				// 	// 		transfer: false,
				// 	// 		card: false,
				// 	// 	},
				// 	// },
				// 	retail: {
				// 		retailpayment: {
				// 			transfer: false,
				// 			card: false,
				// 		},
				// 		matchinginvoicesretail: {
				// 			status: '',
				// 			matchingmethod: '',
				// 		},
				// 		deadlinecomplianceretail: {
				// 			status: '',
				// 		},
				// 	},
				// 	wholesale: {
				// 		wholesalepayment: {
				// 			transfer: false,
				// 			card: false,
				// 		},
				// 		matchinginvoiceswholesale: {
				// 			status: '',
				// 			matchingmethod: '',
				// 		},
				// 		deadlinecompliancewholesale: {
				// 			status: '',
				// 		},
				// 	},
				// 	finance: {
				// 		complianceauditreview: {
				// 			status: '',
				// 		},
				// 	},
				// 	medicine: {
				// 		medicinetype: {
				// 			doctor: false,
				// 			pharmacy: false,
				// 			nurse: false,
				// 			vet: false,
				// 			other: false,
				// 			otherinput: '',
				// 		},
				// 		medicinepayment: {
				// 			card: false,
				// 			benefit: false,
				// 		},
				// 	},
				// 	courier: {
				// 		matchinginvoicescourier: {
				// 			status: '',
				// 			matchingmethod: '',
				// 		},
				// 		deadlinecompliancecourier: {
				// 			status: '',
				// 		},
				// 	},
				// },
				companytype: '',
				foreign_trade: false,
				foreigntradeEU: '',
				vatFilter: '',
				vatPayment: '',
				taxform: '',
			};

			dispatch(
				ACTIONS.updateArrayofObjProviderInfo({
					updatedObj: newCompany,
					arrOfObj: 'provider_example_companies',
				})
			);
		}
	};

	const handleEditCompany = (id) => {
		const selectedCompany = companyData.find((item) => item.id === id);
		if (selectedCompany) {
			setSelectedCompany(selectedCompany);

			setOpenDialogEditCompany(true);
		}
	};

	//

	const handleBlur = (id) => {
		const updatedData = companyData.map((item) =>
			item.id === id ? { ...item, isEditing: false } : item
		);
		//setCompanyData(updatedData);
	};

	const handleDeleteCompany = (filterId) => {
		let tempObj = companyData.filter((e) => {
			return e.id !== filterId;
		});
		dispatch(
			ACTIONS.updateCompleteArray({
				newArray: tempObj,
				ArrayObject: 'provider_example_companies',
			})
		);
	};

	// const confirmDeleteCompany = (filterId) => {
	// 	let tempObj = companyData.filter((i) => i.id !== filterId);
	// 	console.log(tempObj, 'tempObj');

	// 	dispatch(
	// 		ACTIONS.updateArrayofObjProviderInfo({
	// 			updatedObj: tempObj,
	// 			arrOfObj: 'provider_example_companies',
	// 		})
	// 	);
	// 	setOpenAffirmationDelete(false);
	// };

	const handleVisible = (id) => {
		console.log(`handleVisible clicked! ${id}`);
	};

	return (
		<div className={classes.container}>
			<DialogEditCompany
				companyData={selectedCompany}
				openDialogEditCompany={openDialogEditCompany}
				setOpenDialogEditCompany={setOpenDialogEditCompany}
				selectedId={selectedId}
				providerData={providerData}
			/>
			<div className={classes.title}>{i18n.t('provider.calculatortitle')}</div>
			<div className={classes.subtitle}>
				{i18n.t('provider.calculatorsubtitle')}
			</div>
			<div>
				{companyData.map((item) => (
					<div key={item.id} className={classes.companyItem}>
						<div className={classes.companyContent}>
							<div className={classes.companyNameContainer}>
								<img
									src={item.icon}
									alt={item.name}
									className={classes.companyIcon}
								/>
								<span className={classes.companyName}>{item.name}</span>
							</div>
							<div className={classes.companyValue}>
								{item.accountingprice
									? `${i18n.t('provider.monthlyaccountingfee')}: ${
											item.accountingprice
									  }`
									: '-'}
							</div>
						</div>
						<div className={classes.iconButtons}>
							{/* <img
								src={IconVisible}
								alt='Visible'
								className={classes.icon}
								onClick={() => {
									handleVisible(item.id);
									setSelectedId(item.id);
								}}
							/> */}
							<img
								src={IconEdit}
								alt='Edit'
								className={classes.icon}
								onClick={() => {
									handleEditCompany(item.id);
									setSelectedId(item.id);
								}}
							/>
							<img
								src={IconTrashGrey}
								alt='Delete'
								className={classes.icon}
								onClick={() => handleDeleteCompany(item.id)}
							/>
						</div>
					</div>
				))}
			</div>
			{/* <AffirmationDelete
				//openAffirmationDelete={openAffirmationDelete}
				//setOpenAffirmationDelete={setOpenAffirmationDelete}
				title={i18n.t('provider.companydeletion')}
				subTitle={`${i18n.t(
					'provider.examplecompanydeletionaffirmation1'
				)} (-) ${i18n.t('provider.examplecompanydeletionaffirmation2')}`}
				//onConfirmDelete={confirmDeleteCompany}
			/> */}

			<div className={classes.addButton}>
				<CustomButton
					buttonName={i18n.t('provider.addnewcompany')}
					iconSrc={IconPlusBlue}
					buttonColor='#e0e0ff'
					hoverColor='#e0e0ff'
					titleColor='#1c32f3'
					titleHoverColor='#1c32f3'
					width='240px'
					height='44px'
					padding='12px'
					onClick={handleAddCompany}
				/>
			</div>
		</div>
	);
};

export default Calculator;
